import api from './api';
import { withMockFallback } from './mocks/withMockFallback';
import {
  getAnalyticsPolicyMock,
  updateAnalyticsPolicyMock,
} from './mocks/analyticsPolicyMock';

/**
 * Права на изменение правил и зон камеры (Part 4, раздел 6.9) — TARGET FROZEN.
 *
 * rules_edit_mode и zones_edit_mode независимы: одна камера может разрешать
 * клиенту зоны и запрещать правила.
 */

const policyPath = (cameraId) => `/admin/cameras/${cameraId}/analytics-policy`;

export const getAnalyticsPolicy = (cameraId) =>
  withMockFallback(
    () => api.get(policyPath(cameraId)).then((response) => response.data),
    () => getAnalyticsPolicyMock(cameraId)
  );

export const updateAnalyticsPolicy = (cameraId, payload) =>
  withMockFallback(
    () => api.put(policyPath(cameraId), payload).then((response) => response.data),
    () => updateAnalyticsPolicyMock(cameraId, payload)
  );
